import styled from 'styled-components';

export const FilterSelectContainer = styled.div`
  flex-grow: 1;
  max-width: 200px;
  ion-item {
    margin-top: 10px;
    padding: 0;
  }
`;
